import React from 'react';

const Input = ({ 
  label, 
  type = 'text', 
  name, 
  placeholder, 
  value, 
  onChange, 
  error, 
  required = false, 
  className = '',
  autoComplete,
  disabled = false,
  ...props 
}) => {
  const inputId = `input-${name}`;
  const errorId = `${inputId}-error`;

  return (
    <div className={`input-wrapper ${className}`}>
      {label && (
        <label 
          htmlFor={inputId} 
          className="block text-sm font-medium text-foreground mb-2"
        >
          {label}
          {required && <span className="text-error ml-1" aria-label="обязательное поле">*</span>}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        autoComplete={autoComplete}
        className={`w-full px-4 py-3 bg-background border ${
          error ? 'border-error' : 'border-border'
        } rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 ${
          error ? 'focus:ring-error' : 'focus:ring-primary'
        } focus:border-transparent transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed`}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        {...props}
      />
      {error && (
        <p id={errorId} className="mt-1 text-sm text-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;